import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

const VOID_ELEMENTS = ['br', 'hr'];

/**
 * StyledTag:
 *  - Component adds className to whatever html passed to the component
 */
export function StyledTag(props) {
  let className = '';

  if (props.isParent) {
    className = style.tag;
  }

  if (props.className) {
    className += ` ${props.className}`;
  }

  return React.createElement(
    props.tag,
    {className, ...props.tagProps},
    VOID_ELEMENTS.includes(props.tag) ? null : props.children
  );
}

StyledTag.propTypes = {
  /**
   * Name of tag to create
   */
  tag: PropTypes.string,
  /**
   * ClassName to set on the tag
   */
  className: PropTypes.string,
  /**
   * Child components to render inside tag
   */
  children: PropTypes.any,
  /**
   * Additional props that needs to be passed into the tag
   */
  tagProps: PropTypes.object,
  /**
   * Boolean set if tag is parent tag
   */
  isParent: PropTypes.bool,
};

StyledTag.defaultProps = {
  className: '',
  tagProps: {},
};
